import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import clsx from 'clsx';

export function Link({ className, to, children, ...props }) {
  return (
    <GatsbyLink
      {...props}
      className={clsx(className)}
      to={to}
    >
    {children}
    </GatsbyLink>
  )
}

export function BoxLink({ className, to, children, ...props }) {
  return (
    <GatsbyLink
      {...props}
      className={clsx(className, 'block p-10 space-y-5')}
      to={to}
    >
    {children}
    </GatsbyLink>
  )
}